export interface Import {
  file: string;
}

export enum ImportType {
  IMPORT_MACROS = "IMPORT_MACROS",
}

export interface ImportState {
  import: {
    isUploadingFile: boolean;
    importType: ImportType | null;
    importFile: (file?: Import) => void;
    setImportType: (string: ImportType) => void;
  };
}
